// src/modules/app-views/_apps/appmulti/coupons/pages/Document/cardHeaderItems.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  TagOutlined,
  PercentageOutlined,
  NumberOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEMS
// *******************************************************************************
export const couponCodeItem = record => {
  if (!record?.name) return { key: 'couponCode', label: null };
  return {
    key: 'couponCode',
    icon: <TagOutlined />,
    label: String(record.name).toUpperCase(),
    tooltipText: translateX('code'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const couponDiscountItem = record => {
  if (record?.discount == null) return { key: 'couponDiscount', label: null };
  const label = record?.type === 'value' ? `R$ ${record.discount}` : `${record.discount}%`;
  return {
    key: 'couponDiscount',
    icon: <PercentageOutlined />,
    label,
    tooltipText: translateX('discount'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const couponRemainingItem = record => {
  const qty = Number(record?.qty) || 0;
  const used = Number(record?.usedCount) || 0;
  const remaining = record?.__remaining != null ? record.__remaining : Math.max(0, qty - used);
  if (!qty) return { key: 'couponRemaining', label: null };
  return {
    key: 'couponRemaining',
    icon: <NumberOutlined />,
    label: `${remaining} / ${qty}`,
    tooltipText: translateX('quantity'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const couponExpirationItem = record => {
  if (!record?.expirationDate) return { key: 'couponExpiration', label: null };
  return {
    key: 'couponExpiration',
    icon: <CalendarOutlined />,
    label: dayjs(record.expirationDate).format('L'),
    tooltipText: translateX('expiration_date'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};
